import React from "react";

export const game_info2 = (
    <svg
        id="layer1"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="path1402"
            d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,4.07h.037a2.116,2.116,0,1,1-.037,0ZM8.5,9.812h5.592l.027,8.779c0,.809.383,1.038,1.381,1v.342H8.586v-.342c.548-.017,1.458.031,1.389-1.061l0-7.2c-.015-1.237-.611-1.062-1.479-1.168Z"
        />
    </svg>
);
